
const MathUtil = {};

//Range Mapper, with limits
MathUtil.mapRange = function (valIn, minIn, maxIn, minVal, maxVal) {
	if (minIn >= valIn) { return minVal; }
	if (maxIn <= valIn) { return maxVal; }
	return ((valIn - minIn) * (maxVal - minVal)) / (maxIn - minIn) + minVal;
};

MathUtil.distance = function (lat1, lon1, lat2, lon2) {
	var deg2rad = Math.PI / 180;
	lat1 *= deg2rad;
	lon1 *= deg2rad;
	lat2 *= deg2rad;
	lon2 *= deg2rad;
	var diam = 12742; // Diameter of the earth in km (2 * 6371)
	var dLat = lat2 - lat1;
	var dLon = lon2 - lon1;
	var a = (
		(1 - Math.cos(dLat)) +
		(1 - Math.cos(dLon)) * Math.cos(lat1) * Math.cos(lat2)
	) / 2;

	return diam * Math.asin(Math.sqrt(a));
};

MathUtil.padNumber = function (number, digits) {
	return Array(Math.max(digits - String(number).length + 1, 0)).join(0) + number;
};

module.exports = MathUtil;